import { Component, Inject, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  AGIDTOKEN,
  AppleSourceID,
  BingSourceID,
  FacebookSourceID,
  GoogleSourceID,
  InstagramSourceID,
  SyncData,
  XSourceID,
} from '../../local-seo';
import { ListingSyncService } from '../listing-sync.service';

@Component({
  selector: 'local-seo-primary-sources',
  templateUrl: './primary-sources.component.html',
  styleUrls: ['./primary-sources.component.scss'],
  standalone: false,
})
export class PrimarySourcesComponent {
  @Input() sidebarTopPadding = 0;
  @Input() isListingfromEmbedded = false;

  Cards$: Observable<SyncData[]>;
  cardSources = [GoogleSourceID, FacebookSourceID, InstagramSourceID, XSourceID, BingSourceID, AppleSourceID];

  constructor(
    @Inject(AGIDTOKEN) private accountGroupId$: Observable<string>,
    public listingSyncService: ListingSyncService,
  ) {
    this.Cards$ = this.listingSyncService.syncData$.pipe(
      map((sources) =>
        sources
          .filter((source) => this.cardSources.includes(source.sourceId))
          .sort((a, b) => this.cardSources.indexOf(a.sourceId) - this.cardSources.indexOf(b.sourceId)),
      ),
    );
  }
}
